import "./styles/App.css";
import "./styles/blogs/blogs.css";
import "./components/Library.css";
import { Layout } from "@adafia/ui";
import { BrowserRouter, Route } from "react-router-dom";
import { AppRoutes } from "./components/AppRoutes";
import { BlogList } from "./components/blogs/BlogList";
import { BlogPost } from "./components/blogs/BlogPost";
import Contact from "./components/Contact";
import Resources from "./components/Resources";
import { StatusBanner } from "./components/StatusBanner";

function AppContent() {
	return (
		<Layout currentApp="blogs">
			<StatusBanner />
			<AppRoutes>
				<Route
					path="/"
					element={
						<div className="library-container">
							<blockquote className="home-quote">
								<p className="quote-text">
									"In a world where you can be anything,{" "}
									<strong className="text-accent">be kind</strong>."
								</p>
								<cite className="quote-author">— novelist Clare Pooley</cite>
							</blockquote>
							<div className="home-layout">
								<div className="library-content">
									<BlogList />
								</div>
								<aside className="resources-aside">
									<Resources />
								</aside>
							</div>
						</div>
					}
				/>
				<Route
					path="/contact"
					element={
						<div className="library-container">
							<Contact />
						</div>
					}
				/>
				<Route
					path="/blog/:id"
					element={
						<div className="blogs-container">
							<BlogPost />
						</div>
					}
				/>
			</AppRoutes>
		</Layout>
	);
}

export default function App() {
	return (
		<BrowserRouter>
			<AppContent />
		</BrowserRouter>
	);
}
